<template>
  <div v-if="cartItem" class="d-flex justify-space-between align-center">
    <div class="d-flex cart-item" :class="$wait.is(
      `loading clickAndCollect fetchDiscounts ${cartItem.urlSafe}`
    )
        ? 'cart-item-disabled'
        : ''
      ">
      <div>
        <div style="cursor: pointer; position: relative" class="py-2 pr-2">
          <v-img :src="cartItem.ftcCategoryImgUrlsThumbnails[0]" max-width="100"></v-img>
          <FixitFavorite v-if="isUserFavorite"/>
          <!-- <v-icon v-if="$user.onlineSluttKundeId" @click="addAsFavorite()" color="primary">{{`fxt-heart${isUserFavorite? '-filled' : ''}`}}</v-icon> -->
        </div>
      </div>
      <div class="cart-item-description">
        <div style="cursor: pointer">
          <p class="mb-0">{{ cartItem.treatmentName }}</p>
        </div>
        <!-- <p class="mb-1 text-body-2">{{ cartItem.title }}</p>
            <div class="d-flex align-center">
            </div> -->
      </div>
    </div>
    <div class="d-flex align-center">
      <div>
        <v-col class="hidden-xs-only text-right d-flex flex-column" style="white-space: nowrap; justify-content: center">
          <span :style="{
            'font-size': '16px',
            'text-decoration': '',
            'font-weight': '',
          }">kr
            {{ cartItem.pricePerSite.find(x => x.siteId === siteId).price | currency(2, 2) }}
          </span>
        </v-col>
      </div>
      <div>
        <v-col class="align-self-center text-center px-3" cols="1">
          <v-icon color="primary" @click="removeTreatmentFromCart(cartItem)" :disabled="$wait.is(
            `loading clickAndCollect fetchDiscounts ${cartItem.urlSafe}`
          )
            ">fxt-trash</v-icon>
        </v-col>
      </div>
    </div>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import FixitFavorite from "./FixitFavorite.vue"
export default {
  mixins: [webshopMixins],
  components: {
    FixitFavorite
  },
  props: {
    cartItem: Object,
    siteId: Number
  },
  methods: {},
  computed: {
    isUserFavorite() {
      return this.$store.getters['favorites/getFavoriteTreatment'](this.cartItem.treatmentId) != null
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>
  
<style scoped lang="scss">
.total-price {
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;

  &__price {
    font-size: 22px;
    font-weight: 700;
    line-height: 20px;
  }
}

.cart-item {
  &-disabled {
    opacity: 0.5;
  }

  &-description {
    align-self: center;
  }
}
</style>
  